export function getFocusableElements(scope: HTMLElement | null): Element[] {
  if (!scope) return [];
  const selectors = [
    "a[href]",
    "button:not([disabled])",
    "textarea:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    '[tabindex]:not([tabindex="-1"])'
  ].join(",");
  return Array.from(scope.querySelectorAll(selectors)).filter(
    (el) => !(el as HTMLElement).hasAttribute("disabled")
  );
}

export function isInteractive(el: Element | null): boolean {
  if (!el) return false;
  const interactiveSelector =
    'button, a[href], input, select, textarea, [role="button"], [role="link"], [contenteditable="true"]';
  return !!el.closest(interactiveSelector);
}
